/**
 * Carga diferida de libphonenumber-js (metadatos «min»). Solo se pide al montar el campo de
 * teléfono de un checkout, así no suma peso a la carga inicial de fichas, guías ni hubs.
 * Mientras llega, el formulario usa la comprobación de forma E.164 de whatsapp-input.ts.
 */
export type PhoneLib = typeof import('libphonenumber-js/min');

let loaded: PhoneLib | null = null;
let pending: Promise<PhoneLib | null> | null = null;

export function loadPhoneLib(): Promise<PhoneLib | null> {
  if (loaded) return Promise.resolve(loaded);
  if (!pending) {
    pending = import('libphonenumber-js/min')
      .then((mod) => {
        loaded = mod;
        return mod;
      })
      .catch(() => {
        // Sin red o chunk bloqueado: se reintenta en el siguiente montaje.
        pending = null;
        return null;
      });
  }
  return pending;
}

export function getLoadedPhoneLib(): PhoneLib | null {
  return loaded;
}

/** Solo para pruebas en Node: inyecta la librería ya importada. */
export function setPhoneLibForTests(lib: PhoneLib | null): void {
  loaded = lib;
}
